import React from 'react';
import { motion } from 'framer-motion';
const topics = [{
  num: '01',
  title: 'Mentalidad correcta para vender iPhones con anuncios',
  desc: 'Por qué tener muchos mensajes no significa vender más y cómo pensar tus anuncios desde la calidad de la conversación.'
}, {
  num: '02',
  title: 'Entendimiento del negocio iPhone',
  desc: 'Qué tenés que entender de tu negocio antes de pautar: márgenes, modelos, stock y dinámica de compra.'
}, {
  num: '03',
  title: 'Análisis de ventas reales',
  desc: 'Cómo revisar tus ventas anteriores para descubrir qué modelos ganadores conviene anunciar primero.'
}, {
  num: '04',
  title: 'Buyer persona iPhone',
  desc: 'Cómo diferenciar compradores por intención, presupuesto, equipo actual, forma de pago y momento de compra.'
}, {
  num: '05',
  title: 'Elección de productos ganadores',
  desc: 'Cómo decidir qué modelo poner en cada anuncio según tu stock real y la demanda de tu mercado.'
}, {
  num: '06',
  title: 'Creación de ofertas comerciales',
  desc: 'Cómo presentar precio, financiación, garantía, estado y plan canje de forma atractiva.'
}, {
  num: '07',
  title: 'Plan canje como filtro de calidad',
  desc: 'Cómo usar el equipo actual del cliente para atraer personas con más intención y reducir consultas inútiles.'
}, {
  num: '08',
  title: 'Contenido estratégico para anunciar',
  desc: 'Cómo pensar contenido que después puedas convertir en anuncios — no contenido para likes.'
}, {
  num: '09',
  title: 'Anuncios para Instagram y Meta Ads',
  desc: 'Cómo armar anuncios pensados para vender iPhones: hooks, copies, guiones y estructura.'
}, {
  num: '10',
  title: 'Campañas de mensajería',
  desc: 'Cómo estructurar campañas de mensajes para que generen conversaciones más calificadas.'
}, {
  num: '11',
  title: 'Campañas de tráfico al perfil',
  desc: 'Cuándo conviene llevar gente al perfil de Instagram en lugar de directo al chat, y cómo aprovecharlo.'
}, {
  num: '12',
  title: 'Lectura de métricas y análisis de conversaciones',
  desc: 'Qué métricas mirar, cómo leer la calidad real de los mensajes y cómo detectar qué está fallando.'
}, {
  num: '13',
  title: 'Optimización con datos reales',
  desc: 'Cómo decidir qué pausar, qué escalar y qué ajustar usando los datos que te da la campaña.'
}, {
  num: '14',
  title: 'De vender ocasionalmente a tener un sistema',
  desc: 'Cómo pasar de cerrar ventas sueltas a tener un proceso repetible para generar conversaciones todos los meses.'
}];
export function Modules() {
  return <section id="temas" className="py-20 md:py-32 bg-zinc-950" data-id="element-215">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-216">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-217">
          <span className="inline-block text-blue-400 text-sm font-mono font-bold mb-3 uppercase tracking-wider" data-id="element-218">
            Guía principal
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight mb-4" data-id="element-219">
            Qué incluye la guía
          </h2>
          <p className="text-lg text-zinc-400" data-id="element-220">
            14 temas prácticos para entender cómo vender iPhones con anuncios de
            Instagram y Meta Ads.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-221">
          {topics.map((topic, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: Math.min(index * 0.04, 0.4)
        }} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 hover:border-blue-500/50 transition-colors group" data-id="element-222">
              <div className="text-blue-500 font-mono text-sm font-bold mb-3 opacity-80" data-id="element-223">
                Tema {topic.num}
              </div>
              <h3 className="text-lg font-bold text-white mb-3 group-hover:text-blue-400 transition-colors" data-id="element-224">
                {topic.title}
              </h3>
              <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-225">
                {topic.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}